/* Olivine AI Skin Plan quiz runtime, Shopify theme port (FRONT lane).
   Same behaviour as static/quiz.js. Questions come from <api_base>/static/questions.json so the
   server's validation stays the single source; every other string comes from the section
   settings through #skin-plan-quiz-config. Nothing about the questions is hardcoded here. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('skin-plan-quiz-config');
  if (!cfgEl) return;
  var C = {};
  try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) { C = {}; }
  function t(key) { return typeof C[key] === 'string' ? C[key] : ''; }
  function cleanBase(u) {
    u = typeof u === 'string' ? u.trim() : '';
    if (!/^https:\/\/[^\s/]+/.test(u) && !/^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?/.test(u)) return '';
    return u.replace(/\/+$/, '');
  }
  var API_BASE = cleanBase(C.api_base);

  var ASSET_V = '20261011t2'; // bump on every change (the theme's asset_url also versions this file)
  var QUESTIONS_URL = API_BASE + '/static/questions.json?v=' + ASSET_V;
  var SUBMIT_URL = API_BASE + '/api/submit';
  var THANKS_PATH = t('thanks_path') || '/pages/skin-plan-thanks';
  // Preview routing: under ?view=skin-plan* (theme preview of unpublished pages) every internal
  // funnel link stays on the CURRENT path with view=<target suffix>, keeping preview_theme_id and
  // every other query param. Without a view param, links are left exactly as they are.
  function previewHref(href, extra) {
    var here = new URLSearchParams(location.search);
    if ((here.get('view') || '').indexOf('skin-plan') !== 0) return null;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    var m = u.pathname.match(/\/pages\/(skin-plan[a-z0-9_\u002D]*)\/?$/);
    if (!m) return null;
    u.searchParams.forEach(function (v, k) { if (k !== 'view') here.set(k, v); });
    here.set('view', m[1]);
    Object.keys(extra || {}).forEach(function (k) { here.set(k, extra[k]); });
    return location.pathname + '?' + here.toString();
  }
  function routeFunnelLinks(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (a) {
      var to = previewHref(a.getAttribute('href'));
      if (to) a.setAttribute('href', to);
    });
  }

  var STORE_KEY = 'olivine_skin_plan_quiz_v1';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  var LETTERS = 'ABCDEFGHIJ';
  var PRIVACY_URL = t('privacy_path') || '/policies/privacy-policy';
  var TERMS_URL = t('terms_path') || '/policies/terms-of-service';
  var CONTACT_FIELDS = [
    { key: 'first_name', label: t('first_name_label'), name: t('first_name_name'), type: 'text', auto: 'given-name', placeholder: t('first_name_placeholder') },
    { key: 'last_name', label: t('last_name_label'), name: t('last_name_name'), type: 'text', auto: 'family-name', placeholder: t('last_name_placeholder') },
    { key: 'phone', label: t('phone_label'), name: t('phone_name'), type: 'tel', auto: 'tel-national', placeholder: t('phone_placeholder') },
    { key: 'email', label: t('email_label'), name: t('email_name'), type: 'email', auto: 'email', placeholder: t('email_placeholder') }
  ];

  var Q = null;          // parsed questions.json
  var screens = [];      // one entry per question, then the contact screen
  var busy = false;
  var state = {
    i: 0,
    answers: {},
    contact: { first_name: '', last_name: '', phone: '', email: '' },
    sms_consent: false,
    utm: {},
    event_id: null
  };

  var stage = document.getElementById('stage');
  var form = document.getElementById('quiz');
  var prevBtn = document.getElementById('prev');
  var nextBtn = document.getElementById('next');
  var backBtn = document.getElementById('back');
  var okBtn = document.getElementById('ok');
  var okLabel = document.getElementById('ok-label');
  var actionsRow = document.getElementById('actions');
  var bar = document.getElementById('progress');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ADVANCE_MS = 250;     // how long a tapped choice shows as selected before moving on
  var advanceTimer = null;
  var pendingError = null;  // a server error waiting for history navigation to land on its screen

  /* ---------- storage ---------- */
  function save() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (!s || typeof s !== 'object') return;
      if (typeof s.i === 'number') state.i = s.i;
      if (s.answers && typeof s.answers === 'object') state.answers = s.answers;
      if (s.contact && typeof s.contact === 'object') {
        CONTACT_FIELDS.forEach(function (f) { if (typeof s.contact[f.key] === 'string') state.contact[f.key] = s.contact[f.key]; });
      }
      state.sms_consent = s.sms_consent === true;
      if (s.utm && typeof s.utm === 'object') state.utm = s.utm;
      if (typeof s.event_id === 'string') state.event_id = s.event_id;
    } catch (e) { /* ignore broken storage */ }
  }
  function clearStore() {
    try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ }
  }

  function captureUtm() {
    var p = new URLSearchParams(location.search);
    var found = {};
    var any = false;
    UTM_KEYS.forEach(function (k) {
      var v = p.get(k);
      if (v) { found[k] = v.slice(0, 300); any = true; }
    });
    if (any) state.utm = found;
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return [h.slice(0, 8), h.slice(8, 12), h.slice(12, 16), h.slice(16, 20), h.slice(20)].join(String.fromCharCode(45));
  }

  /* ---------- tiny DOM helper ---------- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === 'text') n.textContent = v;
        else if (k === 'className') n.className = v;
        else n.setAttribute(k, v === true ? '' : v);
      });
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function svg(path, size) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('width', size || 16); s.setAttribute('height', size || 16);
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2.4');
    s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', path);
    s.appendChild(p);
    return s;
  }
  var ARROW = 'M5 12h14m-6-6 6 6-6 6';
  var CHECK = 'm5 12 5 5 9-10';

  /* ---------- screens ---------- */
  function buildScreens() {
    screens = Q.questions.map(function (q, idx) { return { kind: 'question', q: q, n: idx + 1 }; });
    screens.push({ kind: 'contact', n: Q.questions.length + 1 });
  }

  function answerOf(q) {
    var v = state.answers[q.id];
    return typeof v === 'string' ? v : '';
  }

  function isAnswered(q) {
    var v = answerOf(q);
    if (q.type === 'choice') return q.options.indexOf(v) !== -1;
    return v.trim().length > 0;
  }

  function firstUnanswered() {
    for (var k = 0; k < Q.questions.length; k += 1) {
      if (!isAnswered(Q.questions[k])) return k;
    }
    return Q.questions.length;
  }

  function head(n, labelText, labelId) {
    return el('div', { className: 'qhead' }, [
      el('span', { className: 'qbadge', 'aria-hidden': 'true' }, [String(n), svg(ARROW, 12)]),
      el('h1', { className: 'qlabel', id: labelId, tabindex: '-1' }, [labelText + ' *'])
    ]);
  }

  function errorBox() {
    var box = el('div', { className: 'err', role: 'alert', id: 'err' });
    box.hidden = true;
    return box;
  }

  function renderQuestion(sc) {
    var q = sc.q;
    var labelId = 'label_' + q.id;
    var wrap = el('div', { className: 'screen', 'data-qid': q.id });
    wrap.appendChild(head(sc.n, q.label, labelId));
    if (q.help) wrap.appendChild(el('p', { className: 'qhelp', text: q.help }));
    var body = el('div', { className: 'qbody' });

    if (q.type === 'choice') {
      var group = el('div', { className: 'options', role: 'radiogroup', 'aria-labelledby': labelId });
      q.options.forEach(function (opt, k) {
        var selected = answerOf(q) === opt;
        var b = el('button', {
          type: 'button', className: 'opt', role: 'radio',
          'aria-checked': selected ? 'true' : 'false', 'data-key': LETTERS[k]
        }, [
          el('span', { className: 'key', 'aria-hidden': 'true', text: LETTERS[k] }),
          el('span', { text: opt }),
          el('span', { className: 'check' }, [svg(CHECK, 18)])
        ]);
        b.addEventListener('click', function () { choose(q, opt, group, true); });
        group.appendChild(b);
      });
      body.appendChild(group);
    } else {
      var max = (Q.limits && Q.limits.text_max_chars) || 2000;
      var ta = el('textarea', {
        className: 'answer', id: 'answer', rows: '1', maxlength: String(max),
        placeholder: t('placeholder'), 'aria-labelledby': labelId, 'aria-required': 'true',
        enterkeyhint: 'next'
      });
      ta.value = answerOf(q);
      ta.addEventListener('input', function () {
        state.answers[q.id] = ta.value;
        save();
        grow(ta);
        hideError();
      });
      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
          e.preventDefault();
          next();
        }
      });
      body.appendChild(ta);
    }
    body.appendChild(errorBox());
    wrap.appendChild(body);
    return wrap;
  }

  function renderContact(sc) {
    var c = Q.contact || {};
    var labelId = 'label_contact';
    var wrap = el('div', { className: 'screen', 'data-qid': 'contact' });
    wrap.appendChild(head(sc.n, c.label || t('contact_title'), labelId));
    var body = el('div', { className: 'qbody' });
    var fields = el('div', { className: 'fields', role: 'group', 'aria-labelledby': labelId });
    var nameMax = (Q.limits && Q.limits.name_max_chars) || 60;

    function field(f) {
      var input = el('input', {
        type: f.type, id: 'f_' + f.key, name: f.key, autocomplete: f.auto,
        placeholder: f.placeholder, 'aria-required': 'true',
        maxlength: f.key === 'phone' ? '20' : (f.key === 'email' ? '254' : String(nameMax)),
        inputmode: f.type === 'tel' ? 'tel' : (f.type === 'email' ? 'email' : null),
        autocapitalize: f.type === 'text' ? 'words' : 'off',
        spellcheck: 'false',
        enterkeyhint: f.key === 'email' ? 'go' : 'next'
      });
      input.value = state.contact[f.key] || '';
      input.addEventListener('input', function () {
        state.contact[f.key] = input.value;
        input.removeAttribute('aria-invalid');
        save();
        hideError();
      });
      // Phone keyboards: Next moves to the next empty field, Go on the last one submits.
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.isComposing) return;
        e.preventDefault();
        var from = CONTACT_FIELDS.indexOf(f);
        for (var j = from + 1; j < CONTACT_FIELDS.length; j += 1) {
          if (!(state.contact[CONTACT_FIELDS[j].key] || '').trim()) {
            document.getElementById('f_' + CONTACT_FIELDS[j].key).focus();
            return;
          }
        }
        next();
      });
      var control = input;
      if (f.key === 'phone') {
        var flag = el('span', { className: 'flag', 'aria-hidden': 'true' }, [usFlag(), '+1']);
        control = el('div', { className: 'phone' }, [flag, input]);
      }
      return el('div', { className: 'field' }, [el('label', { 'for': 'f_' + f.key, text: f.label }), control]);
    }

    fields.appendChild(el('div', { className: 'row2' }, [field(CONTACT_FIELDS[0]), field(CONTACT_FIELDS[1])]));
    fields.appendChild(field(CONTACT_FIELDS[2]));
    fields.appendChild(field(CONTACT_FIELDS[3]));

    var cb = el('input', { type: 'checkbox', id: 'sms_consent', name: 'sms_consent' });
    cb.checked = state.sms_consent === true;
    cb.addEventListener('change', function () { state.sms_consent = cb.checked; save(); });
    fields.appendChild(el('div', { className: 'consent' }, [
      cb,
      el('label', { 'for': 'sms_consent', className: 'smallprint', text: c.sms_consent_text || '' })
    ]));
    fields.appendChild(el('p', { className: 'smallprint legal' }, [
      el('a', { href: PRIVACY_URL, target: '_blank', rel: 'noopener', text: t('privacy_long') }),
      el('span', { 'aria-hidden': 'true', text: ' \u00B7 ' }),
      el('a', { href: TERMS_URL, target: '_blank', rel: 'noopener', text: t('terms_long') })
    ]));

    // Honeypot: real people never see or fill this. Name and label avoid every autofill keyword.
    fields.appendChild(el('div', { className: 'hp', 'aria-hidden': 'true' }, [
      el('label', { 'for': 'hp_extra', text: t('hp_label') }),
      el('input', { type: 'text', id: 'hp_extra', name: 'hp_extra', tabindex: '-1', autocomplete: 'off', 'aria-hidden': 'true' })
    ]));

    body.appendChild(fields);
    body.appendChild(errorBox());
    wrap.appendChild(body);
    return wrap;
  }

  function usFlag() {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('width', '22'); s.setAttribute('height', '15'); s.setAttribute('viewBox', '0 0 22 15'); s.setAttribute('aria-hidden', 'true');
    for (var r = 0; r < 7; r += 1) {
      var stripe = document.createElementNS(ns, 'rect');
      stripe.setAttribute('x', '0');
      stripe.setAttribute('y', String(r * 2 * 15 / 13));
      stripe.setAttribute('width', '22');
      stripe.setAttribute('height', String(15 / 13));
      stripe.setAttribute('fill', '#B22234');
      s.appendChild(stripe);
    }
    var bg = document.createElementNS(ns, 'rect');
    bg.setAttribute('width', '22'); bg.setAttribute('height', '15'); bg.setAttribute('fill', '#FFFFFF');
    s.insertBefore(bg, s.firstChild);
    var canton = document.createElementNS(ns, 'rect');
    canton.setAttribute('width', '9.5'); canton.setAttribute('height', String(15 * 7 / 13)); canton.setAttribute('fill', '#3C3B6E');
    s.appendChild(canton);
    return s;
  }

  function grow(ta) {
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }

  // Select a choice, show it selected for a beat, then move on. No OK needed.
  function choose(q, opt, group, advance) {
    if (busy) return;
    state.answers[q.id] = opt;
    save();
    hideError();
    Array.prototype.forEach.call(group.children, function (b, k) {
      b.setAttribute('aria-checked', q.options[k] === opt ? 'true' : 'false');
    });
    if (!advance) return;
    clearTimeout(advanceTimer);
    var at = state.i;
    if (reduceMotion) { next(); return; }
    advanceTimer = setTimeout(function () { if (state.i === at) next(); }, ADVANCE_MS);
  }

  /* ---------- errors ---------- */
  function showError(msg, focusEl) {
    var box = document.getElementById('err');
    if (!box) return;
    box.textContent = '';
    box.appendChild(svg('M12 8v5m0 3.5v.5M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z', 16));
    box.appendChild(document.createTextNode(msg));
    box.hidden = false;
    if (focusEl) {
      focusEl.setAttribute('aria-invalid', 'true');
      try { focusEl.focus({ preventScroll: false }); } catch (e) { focusEl.focus(); }
    }
  }
  function hideError() {
    var box = document.getElementById('err');
    if (box) box.hidden = true;
  }

  /* ---------- validation ---------- */
  function phoneDigits(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d;
  }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validateContact() {
    var nameMax = (Q.limits && Q.limits.name_max_chars) || 60;
    for (var k = 0; k < CONTACT_FIELDS.length; k += 1) {
      var f = CONTACT_FIELDS[k];
      var v = (state.contact[f.key] || '').trim();
      var input = document.getElementById('f_' + f.key);
      if (!v) return { msg: t('fill_prefix') + ' ' + f.name, input: input };
      if ((f.key === 'first_name' || f.key === 'last_name') && v.length > nameMax) {
        return { msg: t('err_name_long'), input: input };
      }
      if (f.key === 'phone' && phoneDigits(v).length !== 10) {
        return { msg: t('err_phone'), input: input };
      }
      if (f.key === 'email' && !EMAIL_RE.test(v)) {
        return { msg: t('err_email'), input: input };
      }
    }
    return null;
  }

  /* ---------- navigation ---------- */
  // History: one entry per screen reached by moving forward, so the browser and phone back
  // gesture step back through the quiz. Question 1 never gets an extra entry, so back from
  // there leaves normally. Entries carry {olq, quiz, n}: n = entries above the first one.
  function maxIdx() { return Math.min(firstUnanswered(), screens.length - 1); }
  function ours(hs) { return !!(hs && hs.olq === 1 && typeof hs.quiz === 'number' && typeof hs.n === 'number'); }
  function curN() { return ours(history.state) ? history.state.n : 0; }

  function render(dir) {
    clearTimeout(advanceTimer);
    var sc = screens[state.i];
    var node = sc.kind === 'contact' ? renderContact(sc) : renderQuestion(sc);
    if (!reduceMotion && dir) node.classList.add(dir > 0 ? 'enter-down' : 'enter-up');
    stage.textContent = '';
    stage.appendChild(node);
    if (!reduceMotion && dir) {
      void node.offsetHeight;
      requestAnimationFrame(function () { node.classList.remove('enter-down', 'enter-up'); });
    }
    var ta = document.getElementById('answer');
    if (ta) grow(ta);
    bar.style.transform = 'scaleX(' + (state.i / screens.length) + ')';
    prevBtn.disabled = state.i === 0;
    nextBtn.disabled = state.i >= screens.length - 1;
    // Under the answer, inside the card: [Back] [OK] on text screens, [Back] on choice screens.
    var isChoice = sc.kind === 'question' && sc.q.type === 'choice';
    backBtn.hidden = state.i === 0;
    okBtn.hidden = isChoice;
    actionsRow.hidden = backBtn.hidden && okBtn.hidden;
    okLabel.textContent = sc.kind === 'contact' ? t('submit_label') : t('ok_label');
    if (dir) window.scrollTo(0, 0);
    focusScreen(node);
  }

  function focusScreen(node) {
    var target = node.querySelector('textarea, input:not([tabindex="-1"]):not([type="checkbox"])') ||
      node.querySelector('.opt[aria-checked="true"]') || node.querySelector('.opt') || node.querySelector('.qlabel');
    if (!target) return;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  // mode: 'push' adds a history entry (moving forward), 'replace' rewrites the current one.
  function go(idx, mode) {
    if (idx < 0 || idx >= screens.length || idx === state.i) return;
    var dir = idx > state.i ? 1 : -1;
    var n = curN();
    state.i = idx;
    save();
    try {
      if (mode === 'push') history.pushState({ olq: 1, quiz: idx, n: n + 1 }, '');
      else history.replaceState({ olq: 1, quiz: idx, n: n }, '');
    } catch (e) { /* history unavailable: in page navigation still works */ }
    render(dir);
  }

  function next() {
    if (busy) return;
    var sc = screens[state.i];
    if (sc.kind === 'question') {
      if (!isAnswered(sc.q)) {
        showError(t('fill_prefix') + ' ' + sc.q.label, document.getElementById('answer'));
        return;
      }
      if (sc.q.type === 'text') state.answers[sc.q.id] = answerOf(sc.q).trim();
      go(state.i + 1, 'push');
      return;
    }
    var bad = validateContact();
    if (bad) { showError(bad.msg, bad.input); return; }
    submit();
  }

  // Back button, up arrow and ArrowUp all land here. When the previous screen is our own
  // history entry, step the real history so the back gesture and the button stay in sync.
  function prev() {
    if (busy || state.i === 0) return;
    var hs = history.state;
    if (ours(hs) && hs.n > 0 && hs.quiz === state.i) { history.back(); return; }
    go(state.i - 1, 'replace');
  }

  window.addEventListener('popstate', function (e) {
    var hs = e.state;
    if (!Q || !ours(hs)) return;
    clearTimeout(advanceTimer);
    var target = hs.quiz;
    if (target > maxIdx()) {
      // A stale entry (answers were cleared, for example after a finished submit): rewind to
      // the first quiz entry instead of making her swipe through screens that no longer exist.
      if (hs.n > 0) { history.go(-hs.n); return; }
      target = maxIdx();
      history.replaceState({ olq: 1, quiz: target, n: 0 }, '');
    }
    if (target !== state.i) {
      var dir = target > state.i ? 1 : -1;
      state.i = target;
      save();
      render(dir);
    }
    if (pendingError && pendingError.i === state.i) {
      var pe = pendingError;
      pendingError = null;
      showError(pe.msg, document.getElementById('answer'));
    }
  });

  // Back from the thanks page can restore this page from the back forward cache with old state.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var stored = null;
    try { stored = sessionStorage.getItem(STORE_KEY); } catch (err) { stored = null; }
    if (!stored) location.reload();
  });

  /* ---------- phone keyboard ---------- */
  // With the keyboard open, scroll the card so the focused field and the button under it
  // both sit inside the visible area. Nothing is pinned; the page just scrolls.
  function isField(a) { return !!(a && (a.tagName === 'TEXTAREA' || (a.tagName === 'INPUT' && a.type !== 'checkbox'))); }

  function keepVisible() {
    var a = document.activeElement;
    if (!isField(a)) return;
    var vv = window.visualViewport;
    var top = vv ? vv.offsetTop : 0;
    var height = vv ? vv.height : window.innerHeight;
    var bottomLimit = top + height - 12;
    var r = a.getBoundingClientRect();
    var want = r.bottom;
    // One field screen: keep the button in view too. On the contact screen (four fields) only the
    // field she is typing in, or the two targets fight and the page bounces between them.
    var oneField = screens[state.i] && screens[state.i].kind !== 'contact';
    if (oneField && !okBtn.hidden && !actionsRow.hidden) want = Math.max(want, okBtn.getBoundingClientRect().bottom);
    // Never push the field itself above the top of the visible area.
    var shift = Math.min(want - bottomLimit, r.top - top - 12);
    if (want > bottomLimit && shift > 4) window.scrollBy(0, shift);
    else if (r.top < top + 12 - 4) window.scrollBy(0, r.top - top - 12);
  }

  var kbPx = -1;
  function fitViewport() {
    var vv = window.visualViewport;
    // The keyboard's height only. Never subtract vv.offsetTop: that is the SCROLL position, so it
    // changed on every scroll and resized the page, which scrolled it again (the iPhone jumping).
    var hidden = vv ? Math.max(0, Math.round(window.innerHeight - vv.height)) : 0;
    if (Math.abs(hidden - kbPx) > 2) {
      kbPx = hidden;
      // Extra scroll room under the card while the keyboard covers the bottom of the page.
      document.documentElement.style.setProperty('--kb', hidden + 'px');
    }
    keepVisible();
  }

  // Resize only (keyboard opens or closes). No visualViewport 'scroll' listener: our own scrollBy
  // fires it, which looped straight back into fitViewport.
  if (window.visualViewport) window.visualViewport.addEventListener('resize', fitViewport);
  window.addEventListener('resize', fitViewport);
  document.addEventListener('focusin', function () { setTimeout(fitViewport, 60); });

  /* ---------- bot check (Cloudflare Turnstile; on only when the section has a site key) ---------- */
  // Invisible for almost everyone ("interaction-only"); a box appears at the bottom only when
  // Cloudflare wants a click. The token is single use, so it is reset after any refused submit.
  var TS_KEY = /^[0-9A-Za-z_\u002D]{10,100}$/.test(t('turnstile_sitekey')) ? t('turnstile_sitekey') : '';
  var tsWidget = null;
  function tsToken() {
    if (!TS_KEY || tsWidget === null || !window.turnstile) return '';
    try { return window.turnstile.getResponse(tsWidget) || ''; } catch (e) { return ''; }
  }
  function tsReset() {
    if (tsWidget === null || !window.turnstile) return;
    try { window.turnstile.reset(tsWidget); } catch (e) { /* ignore */ }
  }
  function tsBoot() {
    if (!TS_KEY) return;
    var box = document.createElement('div');
    box.className = 'sp-turnstile';
    document.body.appendChild(box);
    window.spTurnstileReady = function () {
      try {
        tsWidget = window.turnstile.render(box, {
          sitekey: TS_KEY, action: 'skin_plan_submit', appearance: 'interaction-only', 'refresh-expired': 'auto'
        });
      } catch (e) { tsWidget = null; }
    };
    var sc = document.createElement('script');
    sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=spTurnstileReady';
    sc.async = true;
    document.head.appendChild(sc);
  }
  // Wait up to 6 s for a token (it is normally ready long before she reaches the last screen).
  function withToken(cb) {
    if (!TS_KEY) { cb(''); return; }
    var waited = 0;
    (function tick() {
      var tok = tsToken();
      if (tok || waited >= 6000) { cb(tok); return; }
      waited += 250;
      setTimeout(tick, 250);
    })();
  }

  /* ---------- submit ---------- */
  function setBusy(on) {
    busy = on;
    okBtn.disabled = on;
    okLabel.textContent = on ? t('sending_label') : t('submit_label');
  }

  function payload() {
    var answers = {};
    Q.questions.forEach(function (q) { answers[q.id] = answerOf(q).trim(); });
    var digits = phoneDigits(state.contact.phone);
    var hp = document.getElementById('hp_extra');
    return {
      answers: answers,
      contact: {
        first_name: state.contact.first_name.trim(),
        last_name: state.contact.last_name.trim(),
        phone: digits.length === 10 ? '+1' + digits : state.contact.phone.trim(),
        email: state.contact.email.trim().toLowerCase()
      },
      sms_consent: state.sms_consent === true,
      utm: state.utm || {},
      event_id: state.event_id,
      hp_extra: hp ? hp.value : ''
    };
  }

  function screenIndexForField(field) {
    if (!field) return -1;
    for (var k = 0; k < screens.length; k += 1) {
      var sc = screens[k];
      if (sc.kind === 'question' && sc.q.id === field) return k;
    }
    if (field === 'contact' || field === 'sms_consent' || CONTACT_FIELDS.some(function (f) { return f.key === field; })) {
      return screens.length - 1;
    }
    return -1;
  }

  function showServerError(data) {
    var field = data && typeof data.field === 'string' ? data.field : '';
    var msg = data && typeof data.error === 'string' && data.error ? data.error : t('err_check');
    var idx = screenIndexForField(field);
    if (idx !== -1 && idx < state.i) {
      // Step the real history back to that screen when the entries are ours, else rewrite.
      var steps = state.i - idx;
      var hs = history.state;
      if (ours(hs) && hs.quiz === state.i && hs.n >= steps) {
        pendingError = { i: idx, msg: msg };
        history.go(-steps);
        return;
      }
      go(idx, 'replace');
    }
    var input = null;
    if (screens[state.i].kind === 'contact') input = document.getElementById('f_' + field);
    else input = document.getElementById('answer');
    showError(msg, input);
  }

  function submit() {
    if (!state.event_id) state.event_id = uuid();
    save();
    setBusy(true);
    withToken(function (tok) {
      var p = payload();
      if (tok) p.turnstile_token = tok;
      var body = JSON.stringify(p);
      fetch(SUBMIT_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, credentials: 'omit', mode: 'cors' })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) { return { status: r.status, ok: r.ok, data: data || {} }; });
        })
        .then(function (res) {
          if (res.ok) {
            // The thanks page is a theme page: <thanks_path>?l=<lead_id>&s=<1 if texts>.
            var lead = typeof res.data.lead_id === 'string' && /^[A-Za-z0-9_\u002D]{4,64}$/.test(res.data.lead_id) ? res.data.lead_id : '';
            var params = { s: state.sms_consent === true ? '1' : '0' };
            if (lead) params.l = lead;
            var url = previewHref(THANKS_PATH, params) || (THANKS_PATH + (THANKS_PATH.indexOf('?') === -1 ? '?' : '&') +
              (lead ? 'l=' + encodeURIComponent(lead) + '&' : '') + 's=' + params.s);
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'Lead', {}, { eventID: state.event_id });
            }
            clearStore();
            setTimeout(function () { location.assign(url); }, 400);
            return;
          }
          setBusy(false);
          tsReset();
          if (res.status === 429) {
            showError(t('err_rate'), null);
          } else if (res.status === 403 && TS_KEY && !window.turnstile) {
            // the check never loaded (a blocker or extension): pressing again cannot help
            showError(t('err_bot_blocked') || t('err_server'), null);
          } else if (res.status === 403 && res.data && typeof res.data.error === 'string' && res.data.error) {
            showError(res.data.error, null);
          } else if (res.status === 400) {
            showServerError(res.data);
          } else {
            showError(t('err_server'), null);
          }
        })
        .catch(function () {
          setBusy(false);
          tsReset();
          showError(t('err_network'), null);
        });
    });
  }

  /* ---------- keyboard ---------- */
  document.addEventListener('keydown', function (e) {
    if (!Q || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target;
    // Never steal keys while she is typing: textareas and inputs handle their own Enter.
    if (t && (t.tagName === 'TEXTAREA' || t.tagName === 'INPUT' || t.isContentEditable)) return;
    if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); prev(); return; }
    if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); next(); return; }
    var sc = screens[state.i];
    if (sc && sc.kind === 'question' && sc.q.type === 'choice' && e.key.length === 1) {
      var k = LETTERS.indexOf(e.key.toUpperCase());
      if (k !== -1 && k < sc.q.options.length) {
        e.preventDefault();
        var group = stage.querySelector('.options');
        var btn = group.children[k];
        if (btn) btn.focus();
        choose(sc.q, sc.q.options[k], group, true);
        return;
      }
    }
    if (e.key === 'Enter' && !(t && (t.tagName === 'BUTTON' || t.tagName === 'A'))) {
      e.preventDefault();
      next();
    }
  });

  form.addEventListener('submit', function (e) { e.preventDefault(); next(); });
  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);
  backBtn.addEventListener('click', prev);
  okBtn.addEventListener('click', next);

  /* ---------- boot ---------- */
  routeFunnelLinks(document);
  restore();
  captureUtm();
  save();

  if (!API_BASE) {
    // Not configured: the section already rendered the note (plus an editor hint in the theme
    // editor). Keep it; only add one if the markup is missing.
    if (!stage.querySelector('.sp-config-note')) {
      stage.textContent = '';
      stage.appendChild(el('p', { className: 'sp-config-note', text: t('not_configured') }));
    }
    return;
  }
  tsBoot();
  fetch(QUESTIONS_URL, { cache: 'no-cache', credentials: 'omit', mode: 'cors' })
    .then(function (r) { if (!r.ok) throw new Error('questions'); return r.json(); })
    .then(function (data) {
      if (!data || !Array.isArray(data.questions) || !data.questions.length) throw new Error('questions');
      Q = data;
      // Drop stored choice answers that no longer match an option.
      Q.questions.forEach(function (q) {
        if (q.type === 'choice' && state.answers[q.id] !== undefined && q.options.indexOf(state.answers[q.id]) === -1) delete state.answers[q.id];
      });
      buildScreens();
      var max = maxIdx();
      var hs = history.state;
      var rewind = 0;
      if (ours(hs)) {
        // Reload or return to an existing entry: the entry says which screen this is.
        if (hs.quiz <= max) state.i = hs.quiz;
        else if (hs.n > 0) rewind = hs.n;
      }
      state.i = Math.max(0, Math.min(state.i, max));
      try { history.replaceState({ olq: 1, quiz: state.i, n: ours(hs) ? hs.n : 0 }, ''); } catch (e) { /* ignore */ }
      save();
      render(0);
      fitViewport();
      if (rewind) history.go(-rewind);
    })
    .catch(function () {
      stage.textContent = '';
      stage.appendChild(el('p', { className: 'loading', text: t('load_error') }));
    });
})();
